import { Injectable } from '@angular/core';

interface LearnPlannerState {
  [plannerId: string]: boolean; // true = expanded, false = collapsed
}

@Injectable({
  providedIn: 'root'
})
export class LearnStorageService {
  private readonly STORAGE_KEY = 'learn-planner-state';

  getPlannerState(plannerId: string): boolean {
    try {
      const state: LearnPlannerState = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '{}');
      return state[plannerId] ?? false;
    } catch {
      return false;
    }
  }

  setPlannerState(plannerId: string, expanded: boolean): void {
    try {
      const state: LearnPlannerState = JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '{}');
      state[plannerId] = expanded;
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state));
    } catch {
      // Fail silently if localStorage is not available
    }
  }

  clearPlannerState(): void {
    try {
      localStorage.removeItem(this.STORAGE_KEY);
    } catch {
      // Fail silently if localStorage is not available
    }
  }
}